import { ArrowForwardIos, Menu as MenuIcon } from '@interhyp/platform-icons';
import { useActiveIntent } from '@interhyp/shared-interim-portal';
import { Drawer, IconButton, ResetButton, SMALL_ICON_SIZE } from '@platform/elements';
import classnames from 'classnames';
import { useEffect, useRef, useState } from 'react';

import styles from './MobileDrawer.module.scss';
import { MobileDrawerItem } from './MobileDrawerItem';
import { MobileNavHint } from './MobileNavHint';
import { LocalDefinedRoute } from '../../../views/secure/mortgage/hooks/useMortgageContextNavigation';
import { MortgageIntent } from '../../IntentToggle/components/MortgageIntent';
import { useIntentToggle } from '../../IntentToggle/hooks/useIntentToggle';

export function MobileDrawer({
  mainNavigation,
}: {
  mainNavigation: LocalDefinedRoute[];
}): React.ReactElement {
  const activeIntent = useActiveIntent();
  const [open, setOpen] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);

  const toggleButton = useRef<HTMLButtonElement>(null);

  const { intents, onSelect } = useIntentToggle();

  useEffect(() => {
    if (!open) {
      setDetailOpen(false);
    }
  }, [open]);

  return (
    <>
      <MobileNavHint mainNavigation={mainNavigation}>
        <IconButton
          ref={toggleButton}
          className={styles.hamburger}
          tertiary
          icon={MenuIcon}
          onClick={() => setOpen(prev => !prev)}
        />
      </MobileNavHint>

      <Drawer
        className={styles.drawer}
        open={open}
        anchor="right"
        variant="navigation"
        onClickOutside={event => {
          const target = event?.target as Node;
          const button = toggleButton.current;

          // If the button was clicked it should handle the close and therefore the outside click should be ignored
          if (button === target || (target && button?.contains(target))) {
            return;
          }

          setOpen(false);
        }}
      >
        <div className={styles.drawerContent}>
          {detailOpen ? (
            <>
              <ResetButton className={styles.header} onClick={() => setDetailOpen(false)}>
                <ArrowForwardIos className={styles.backButton} size={SMALL_ICON_SIZE} />
                <strong>Meine Anträge</strong> <div />
              </ResetButton>

              {intents.map(intent => (
                <ResetButton
                  className={classnames(styles.drawerIntentButton, {
                    [styles.active]: activeIntent?.intentId === intent.intentId,
                  })}
                  onClick={() => {
                    onSelect({ key: intent.intentId ?? '' });
                    setOpen(false);
                  }}
                >
                  <MortgageIntent intent={intent} />
                </ResetButton>
              ))}
            </>
          ) : (
            <>
              <MobileDrawerItem label="Meine Anträge" to="/" exact />
              {mainNavigation.map(item => (
                <MobileDrawerItem
                  key={item.path}
                  label={item.label}
                  to={item.path}
                  exact={item.exact}
                  onClick={() => setOpen(false)}
                />
              ))}
            </>
          )}
        </div>
      </Drawer>
    </>
  );
}
